export default __webpack_public_path__ + "static/759-85171c9daed4052c92f182f4935cefb5.gif";